module.exports = __webpack_public_path__ + "static/Prof.KenUrabeMDPhDJEPANG-cec97806bae9124b0f7ecd9c2c321bb1.jpg";